import React from 'react'
import {Icon} from '@chakra-ui/react'

const AddToCartModalCheckIcon = (props) => {
    return (
        <Icon viewBox="2 2 16 16" fill="none" {...props}>
            <g filter="url(#filter0_ddi)">
                <path
                    d="M2 9C2 4.58172 5.58172 1 10 1C14.4183 1 18 4.58172 18 9C18 13.4183 14.4183 17 10 17C5.58172 17 2 13.4183 2 9Z"
                    fill="var(--chakra-colors-background-base-check-icon-modal)"
                />
                <path
                    d="M10 1.5C14.1421 1.5 17.5 4.85786 17.5 9C17.5 13.1421 14.1421 16.5 10 16.5C5.85786 16.5 2.5 13.1421 2.5 9C2.5 4.85786 5.85786 1.5 10 1.5Z"
                    stroke="white"
                />
                <path
                    d="M12.9091 6.0762C13.1435 5.84202 13.5235 5.84193 13.7578 6.0762C13.9915 6.31044 13.9916 6.68966 13.7578 6.92385L9.17476 11.5078C9.06233 11.6203 8.90894 11.6835 8.74995 11.6836C8.59115 11.6835 8.43853 11.62 8.32613 11.5078L6.24312 9.42385C6.0088 9.18954 6.0088 8.81051 6.24312 8.5762C6.47744 8.34202 6.85651 8.34193 7.09078 8.5762L8.74995 10.2344L12.9091 6.0762Z"
                    fill="#EFEDEA"
                />
            </g>
            <defs>
                <filter
                    id="filter0_ddi"
                    x="0"
                    y="0"
                    width="20"
                    height="20"
                    filterUnits="userSpaceOnUse"
                    colorInterpolationFilters="sRGB"
                >
                    <feFlood floodOpacity="0" result="BackgroundImageFix" />
                    <feColorMatrix
                        in="SourceAlpha"
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                        result="hardAlpha"
                    />
                    <feMorphology
                        radius="1"
                        operator="dilate"
                        in="SourceAlpha"
                        result="effect1_dropShadow"
                    />
                    <feOffset />
                    <feComposite in2="hardAlpha" operator="out" />
                    <feColorMatrix
                        type="matrix"
                        values="0 0 0 0 0.0745098 0 0 0 0 0.0941176 0 0 0 0 0.227451 0 0 0 0.08 0"
                    />
                    <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow" />
                    <feColorMatrix
                        in="SourceAlpha"
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                        result="hardAlpha"
                    />
                    <feOffset dy="1" />
                    <feGaussianBlur stdDeviation="1" />
                    <feComposite in2="hardAlpha" operator="out" />
                    <feColorMatrix
                        type="matrix"
                        values="0 0 0 0 0.0745098 0 0 0 0 0.0941176 0 0 0 0 0.227451 0 0 0 0.08 0"
                    />
                    <feBlend mode="normal" in2="effect1_dropShadow" result="effect2_dropShadow" />
                    <feBlend
                        mode="normal"
                        in="SourceGraphic"
                        in2="effect2_dropShadow"
                        result="shape"
                    />
                    <feColorMatrix
                        in="SourceAlpha"
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                        result="hardAlpha"
                    />
                    <feMorphology
                        radius="1"
                        operator="erode"
                        in="SourceAlpha"
                        result="effect3_innerShadow"
                    />
                    <feOffset />
                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                    <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0" />
                    <feBlend mode="normal" in2="shape" result="effect3_innerShadow" />
                </filter>
            </defs>
        </Icon>
    )
}

export default AddToCartModalCheckIcon
